import accessibility_ca_edv from './ca_edv/accessibility.json';
import auth_ca_edv from './ca_edv/auth.json';
import calendar_ca_edv from './ca_edv/calendar.json';
import classroom_ca_edv from './ca_edv/classroom.json';
import common_ca_edv from './ca_edv/common.json';
import courses_ca_edv from './ca_edv/courses.json';
import demo_ca_edv from './ca_edv/demo.json';
import editorial_ca_edv from './ca_edv/editorial.json';
import grades_ca_edv from './ca_edv/grades.json';
import header_ca_edv from './ca_edv/header.json';
import kanban_ca_edv from './ca_edv/kanban.json';
import lemonade_ca_edv from './ca_edv/lemonade.json';
import lesson_ca_edv from './ca_edv/lesson.json';
import phrase_ca_edv from './ca_edv/phrase.json';
import profile_ca_edv from './ca_edv/profile.json';
import project_ca_edv from './ca_edv/project.json';
import signup_ca_edv from './ca_edv/signup.json';
import tasks_ca_edv from './ca_edv/tasks.json';
import test_ca_edv from './ca_edv/test.json';
import titles_ca_edv from './ca_edv/titles.json';
import titles_en_edv from './en_edv/titles.json';
import titles_es_edv from './es_edv/titles.json';
import auth_en_edv from './en_edv/auth.json';
import calendar_en_edv from './en_edv/calendar.json';
import classroom_en_edv from './en_edv/classroom.json';
import common_en_edv from './en_edv/common.json';
import courses_en_edv from './en_edv/courses.json';
import demo_en_edv from './en_edv/demo.json';
import editorial_en_edv from './en_edv/editorial.json';
import grades_en_edv from './en_edv/grades.json';
import header_en_edv from './en_edv/header.json';
import kanban_en_edv from './en_edv/kanban.json';
import lemonade_en_edv from './en_edv/lemonade.json';
import lesson_en_edv from './en_edv/lesson.json';
import phrase_en_edv from './en_edv/phrase.json';
import profile_en_edv from './en_edv/profile.json';
import project_en_edv from './en_edv/project.json';
import signup_en_edv from './en_edv/signup.json';
import tasks_en_edv from './en_edv/tasks.json';
import test_en_edv from './en_edv/test.json';
import { default as auth_en_gotitbyme, default as auth_es_gotitbyme } from './en_gotitbyme/auth.json';
import { default as calendar_en_gotitbyme, default as calendar_es_gotitbyme } from './en_gotitbyme/calendar.json';
import { default as common_en_gotitbyme, default as common_es_gotitbyme } from './en_gotitbyme/common.json';
import { default as courses_en_gotitbyme, default as courses_es_gotitbyme } from './en_gotitbyme/courses.json';
import { default as editorial_en_gotitbyme, default as editorial_es_gotitbyme } from './en_gotitbyme/editorial.json';
import { default as grades_en_gotitbyme, default as grades_es_gotitbyme } from './en_gotitbyme/grades.json';
import { default as header_en_gotitbyme, default as header_es_gotitbyme } from './en_gotitbyme/header.json';
import { default as kanban_en_gotitbyme, default as kanban_es_gotitbyme } from './en_gotitbyme/kanban.json';
import { default as lemonade_en_gotitbyme, default as lemonade_es_gotitbyme } from './en_gotitbyme/lemonade.json';
import { default as lesson_en_gotitbyme, default as lesson_es_gotitbyme } from './en_gotitbyme/lesson.json';
import { default as profile_en_gotitbyme, default as profile_es_gotitbyme } from './en_gotitbyme/profile.json';
import { default as project_en_gotitbyme, default as project_es_gotitbyme } from './en_gotitbyme/project.json';
import { default as signup_en_gotitbyme, default as signup_es_gotitbyme } from './en_gotitbyme/signup.json';
import { default as tasks_en_gotitbyme, default as tasks_es_gotitbyme } from './en_gotitbyme/tasks.json';
import { default as teams_en_gotitbyme, default as teams_es_gotitbyme } from './en_gotitbyme/teams.json';
import { default as test_en_gotitbyme, default as test_es_gotitbyme } from './en_gotitbyme/test.json';
import auth_en_macmillan from './en_macmillan/auth.json';
import calendar_en_macmillan from './en_macmillan/calendar.json';
import common_en_macmillan from './en_macmillan/common.json';
import courses_en_macmillan from './en_macmillan/courses.json';
import editorial_en_macmillan from './en_macmillan/editorial.json';
import grades_en_macmillan from './en_macmillan/grades.json';
import header_en_macmillan from './en_macmillan/header.json';
import lemonade_en_macmillan from './en_macmillan/lemonade.json';
import lesson_en_macmillan from './en_macmillan/lesson.json';
import profile_en_macmillan from './en_macmillan/profile.json';
import project_en_macmillan from './en_macmillan/project.json';
import signup_en_macmillan from './en_macmillan/signup.json';
import tasks_en_macmillan from './en_macmillan/tasks.json';
import teams_en_macmillan from './en_macmillan/teams.json';
import test_en_macmillan from './en_macmillan/test.json';
import auth_es_edv from './es_edv/auth.json';
import calendar_es_edv from './es_edv/calendar.json';
import classroom_es_edv from './es_edv/classroom.json';
import common_es_edv from './es_edv/common.json';
import courses_es_edv from './es_edv/courses.json';
import demo_es_edv from './es_edv/demo.json';
import editorial_es_edv from './es_edv/editorial.json';
import grades_es_edv from './es_edv/grades.json';
import header_es_edv from './es_edv/header.json';
import kanban_es_edv from './es_edv/kanban.json';
import lemonade_es_edv from './es_edv/lemonade.json';
import lesson_es_edv from './es_edv/lesson.json';
import phrase_es_edv from './es_edv/phrase.json';
import profile_es_edv from './es_edv/profile.json';
import project_es_edv from './es_edv/project.json';
import signup_es_edv from './es_edv/signup.json';
import tasks_es_edv from './es_edv/tasks.json';
import test_es_edv from './es_edv/test.json';
import auth_es_macmillan from './es_macmillan/auth.json';
import calendar_es_macmillan from './es_macmillan/calendar.json';
import common_es_macmillan from './es_macmillan/common.json';
import courses_es_macmillan from './es_macmillan/courses.json';
import editorial_es_macmillan from './es_macmillan/editorial.json';
import grades_es_macmillan from './es_macmillan/grades.json';
import header_es_macmillan from './es_macmillan/header.json';
import lemonade_es_macmillan from './es_macmillan/lemonade.json';
import lesson_es_macmillan from './es_macmillan/lesson.json';
import profile_es_macmillan from './es_macmillan/profile.json';
import project_es_macmillan from './es_macmillan/project.json';
import signup_es_macmillan from './es_macmillan/signup.json';
import tasks_es_macmillan from './es_macmillan/tasks.json';
import teams_es_macmillan from './es_macmillan/teams.json';
import test_es_macmillan from './es_macmillan/test.json';
import courses_es_santillana_cr_compartir from './es_santillana_cr_compartir/courses.json';
import grades_es_santillana_cr_compartir from './es_santillana_cr_compartir/grades.json';
import courses_es_santillana_do_compartir from './es_santillana_do_compartir/courses.json';
import grades_es_santillana_do_compartir from './es_santillana_do_compartir/grades.json';
import courses_es_santillana_gt_compartir from './es_santillana_gt_compartir/courses.json';
import grades_es_santillana_gt_compartir from './es_santillana_gt_compartir/grades.json';
import courses_es_santillana_hn from './es_santillana_hn/courses.json';
import grades_es_santillana_hn from './es_santillana_hn/grades.json';
import courses_es_santillana_mx_compartir from './es_santillana_mx_compartir/courses.json';
import grades_es_santillana_mx_compartir from './es_santillana_mx_compartir/grades.json';
import grades_es_santillana_ni_compartir from './es_santillana_ni_compartir/grades.json';
import grades_es_santillana_pa_compartir from './es_santillana_pa_compartir/grades.json';
import accessibility_eu_edv from './eu_edv/accessibility.json';
import auth_eu_edv from './eu_edv/auth.json';
import calendar_eu_edv from './eu_edv/calendar.json';
import classroom_eu_edv from './eu_edv/classroom.json';
import common_eu_edv from './eu_edv/common.json';
import courses_eu_edv from './eu_edv/courses.json';
import demo_eu_edv from './eu_edv/demo.json';
import editorial_eu_edv from './eu_edv/editorial.json';
import grades_eu_edv from './eu_edv/grades.json';
import header_eu_edv from './eu_edv/header.json';
import kanban_eu_edv from './eu_edv/kanban.json';
import lemonade_eu_edv from './eu_edv/lemonade.json';
import lesson_eu_edv from './eu_edv/lesson.json';
import phrase_eu_edv from './eu_edv/phrase.json';
import profile_eu_edv from './eu_edv/profile.json';
import project_eu_edv from './eu_edv/project.json';
import signup_eu_edv from './eu_edv/signup.json';
import tasks_eu_edv from './eu_edv/tasks.json';
import test_eu_edv from './eu_edv/test.json';
import titles_eu_edv from './eu_edv/titles.json';
import accessibility_gl_edv from './gl_edv/accessibility.json';
import auth_gl_edv from './gl_edv/auth.json';
import calendar_gl_edv from './gl_edv/calendar.json';
import classroom_gl_edv from './gl_edv/classroom.json';
import common_gl_edv from './gl_edv/common.json';
import courses_gl_edv from './gl_edv/courses.json';
import demo_gl_edv from './gl_edv/demo.json';
import editorial_gl_edv from './gl_edv/editorial.json';
import grades_gl_edv from './gl_edv/grades.json';
import header_gl_edv from './gl_edv/header.json';
import kanban_gl_edv from './gl_edv/kanban.json';
import lemonade_gl_edv from './gl_edv/lemonade.json';
import lesson_gl_edv from './gl_edv/lesson.json';
import phrase_gl_edv from './gl_edv/phrase.json';
import profile_gl_edv from './gl_edv/profile.json';
import project_gl_edv from './gl_edv/project.json';
import signup_gl_edv from './gl_edv/signup.json';
import tasks_gl_edv from './gl_edv/tasks.json';
import test_gl_edv from './gl_edv/test.json';
import titles_gl_edv from './gl_edv/titles.json';
import { mergeTranslations } from './mergeTranslations';
import accessibility_mx_edv from './mx_edv/accessibility.json';
import auth_mx_edv from './mx_edv/auth.json';
import calendar_mx_edv from './mx_edv/calendar.json';
import classroom_mx_edv from './mx_edv/classroom.json';
import common_mx_edv from './mx_edv/common.json';
import courses_mx_edv from './mx_edv/courses.json';
import demo_mx_edv from './mx_edv/demo.json';
import editorial_mx_edv from './mx_edv/editorial.json';
import grades_mx_edv from './mx_edv/grades.json';
import header_mx_edv from './mx_edv/header.json';
import kanban_mx_edv from './mx_edv/kanban.json';
import lemonade_mx_edv from './mx_edv/lemonade.json';
import lesson_mx_edv from './mx_edv/lesson.json';
import phrase_mx_edv from './mx_edv/phrase.json';
import profile_mx_edv from './mx_edv/profile.json';
import project_mx_edv from './mx_edv/project.json';
import signup_mx_edv from './mx_edv/signup.json';
import tasks_mx_edv from './mx_edv/tasks.json';
import test_mx_edv from './mx_edv/test.json';
import titles_mx_edv from './mx_edv/titles.json';
import courses_pt_modernacoreeducacao_br from './pt_modernacoreeducacao_br/courses.json';
import grades_pt_modernacoreeducacao_br from './pt_modernacoreeducacao_br/grades.json';
import lesson_pt_modernacoreeducacao_br from './pt_modernacoreeducacao_br/lesson.json';
import common_pt_santillana_br_compartir from './pt_santillana_br/common.json';
import courses_pt_santillana_br_compartir from './pt_santillana_br/courses.json';
import grades_pt_santillana_br_compartir from './pt_santillana_br/grades.json';
import header_pt_santillana_br_compartir from './pt_santillana_br/header.json';
import lesson_pt_santillana_br_compartir from './pt_santillana_br/lesson.json';
import library_pt_santillana_br_compartir from './pt_santillana_br/library.json';
import tasks_pt_santillana_br_compartir from './pt_santillana_br/tasks.json';
import test_pt_santillana_br_compartir from './pt_santillana_br/test.json';
import { DEFAULT_RESOURCES_EN, DEFAULT_RESOURCES_ES, DEFAULT_RESOURCES_PT } from './resourcesDefault';
import accessibility_vl_edv from './vl_edv/accessibility.json';
import auth_vl_edv from './vl_edv/auth.json';
import calendar_vl_edv from './vl_edv/calendar.json';
import classroom_vl_edv from './vl_edv/classroom.json';
import common_vl_edv from './vl_edv/common.json';
import courses_vl_edv from './vl_edv/courses.json';
import demo_vl_edv from './vl_edv/demo.json';
import editorial_vl_edv from './vl_edv/editorial.json';
import grades_vl_edv from './vl_edv/grades.json';
import header_vl_edv from './vl_edv/header.json';
import kanban_vl_edv from './vl_edv/kanban.json';
import lemonade_vl_edv from './vl_edv/lemonade.json';
import lesson_vl_edv from './vl_edv/lesson.json';
import phrase_vl_edv from './vl_edv/phrase.json';
import profile_vl_edv from './vl_edv/profile.json';
import project_vl_edv from './vl_edv/project.json';
import signup_vl_edv from './vl_edv/signup.json';
import tasks_vl_edv from './vl_edv/tasks.json';
import test_vl_edv from './vl_edv/test.json';
import titles_vl_edv from './vl_edv/titles.json';

export const MACMILLAN = {
  en_Macmillan: mergeTranslations(DEFAULT_RESOURCES_EN, [
    auth_en_macmillan,
    courses_en_macmillan,
    common_en_macmillan,
    header_en_macmillan,
    calendar_en_macmillan,
    lesson_en_macmillan,
    profile_en_macmillan,
    signup_en_macmillan,
    tasks_en_macmillan,
    test_en_macmillan,
    lemonade_en_macmillan,
    grades_en_macmillan,
    project_en_macmillan,
    editorial_en_macmillan,
    teams_en_macmillan,
  ]),
  es_Macmillan: mergeTranslations(DEFAULT_RESOURCES_ES, [
    auth_es_macmillan,
    courses_es_macmillan,
    common_es_macmillan,
    header_es_macmillan,
    calendar_es_macmillan,
    lesson_es_macmillan,
    profile_es_macmillan,
    signup_es_macmillan,
    tasks_es_macmillan,
    test_es_macmillan,
    lemonade_es_macmillan,
    grades_es_macmillan,
    project_es_macmillan,
    editorial_es_macmillan,
    teams_es_macmillan,
  ]),
};

export const GOTITBYME = {
  en_GotItByME: mergeTranslations(DEFAULT_RESOURCES_EN, [
    auth_en_gotitbyme,
    courses_en_gotitbyme,
    common_en_gotitbyme,
    header_en_gotitbyme,
    calendar_en_gotitbyme,
    lesson_en_gotitbyme,
    profile_en_gotitbyme,
    signup_en_gotitbyme,
    tasks_en_gotitbyme,
    test_en_gotitbyme,
    lemonade_en_gotitbyme,
    grades_en_gotitbyme,
    project_en_gotitbyme,
    editorial_en_gotitbyme,
    teams_en_gotitbyme,
    kanban_en_gotitbyme,
  ]),
  es_GotItByME: mergeTranslations(DEFAULT_RESOURCES_ES, [
    auth_es_gotitbyme,
    courses_es_gotitbyme,
    common_es_gotitbyme,
    header_es_gotitbyme,
    calendar_es_gotitbyme,
    lesson_es_gotitbyme,
    profile_es_gotitbyme,
    signup_es_gotitbyme,
    tasks_es_gotitbyme,
    test_es_gotitbyme,
    lemonade_es_gotitbyme,
    grades_es_gotitbyme,
    project_es_gotitbyme,
    editorial_es_gotitbyme,
    teams_es_gotitbyme,
    kanban_es_gotitbyme,
  ]),
};

export const SANTILLANA_NI_COMPARTIR = {
  'es_Compartir NI': mergeTranslations(DEFAULT_RESOURCES_ES, [grades_es_santillana_ni_compartir]),
  'en_Compartir NI': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir NI': [...DEFAULT_RESOURCES_PT],
};

export const SANTILLANA_PA_COMPARTIR = {
  'es_Compartir PA': mergeTranslations(DEFAULT_RESOURCES_ES, [grades_es_santillana_pa_compartir]),
  'en_Compartir PA': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir PA': [...DEFAULT_RESOURCES_PT],
};

export const SANTILLANA_CR_COMPARTIR = {
  'es_Compartir CR': mergeTranslations(DEFAULT_RESOURCES_ES, [courses_es_santillana_cr_compartir, grades_es_santillana_cr_compartir]),
  'en_Compartir CR': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir CR': [...DEFAULT_RESOURCES_PT],
};

export const SANTILLANA_DO_COMPARTIR = {
  'es_Compartir DO': mergeTranslations(DEFAULT_RESOURCES_ES, [courses_es_santillana_do_compartir, grades_es_santillana_do_compartir]),
  'en_Compartir DO': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir DO': [...DEFAULT_RESOURCES_PT],
};

export const SANTILLANA_GT_COMPARTIR = {
  'es_Compartir-GT': mergeTranslations(DEFAULT_RESOURCES_ES, [courses_es_santillana_gt_compartir, grades_es_santillana_gt_compartir]),
  'en_Compartir-GT': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir-GT': [...DEFAULT_RESOURCES_PT],
};

export const SANTILLANA_BR_COMPARTIR = {
  'es_Compartir-BR': [...DEFAULT_RESOURCES_ES],
  'en_Compartir-BR': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir-BR': mergeTranslations(DEFAULT_RESOURCES_PT, [
    common_pt_santillana_br_compartir,
    courses_pt_santillana_br_compartir,
    grades_pt_santillana_br_compartir,
    lesson_pt_santillana_br_compartir,
    header_pt_santillana_br_compartir,
    library_pt_santillana_br_compartir,
    tasks_pt_santillana_br_compartir,
    test_pt_santillana_br_compartir,
  ]),
};

export const SANTILLANA_BR_UNOI = {
  'es_UnoInt-BR': [...DEFAULT_RESOURCES_ES],
  'en_UnoInt-BR': [...DEFAULT_RESOURCES_EN],
  'pt_UnoInt-BR': mergeTranslations(DEFAULT_RESOURCES_PT, [
    common_pt_santillana_br_compartir,
    courses_pt_santillana_br_compartir,
    grades_pt_santillana_br_compartir,
    lesson_pt_santillana_br_compartir,
    header_pt_santillana_br_compartir,
    library_pt_santillana_br_compartir,
    tasks_pt_santillana_br_compartir,
    test_pt_santillana_br_compartir,
  ]),
};

export const SANTILLANA_BR_MODERNAEDUCACAO = {
  'es_Sumun BR': [...DEFAULT_RESOURCES_ES],
  'en_Sumun BR': [...DEFAULT_RESOURCES_EN],
  'pt_Sumun BR': mergeTranslations(DEFAULT_RESOURCES_PT, [
    courses_pt_modernacoreeducacao_br,
    grades_pt_modernacoreeducacao_br,
    lesson_pt_modernacoreeducacao_br,
  ]),
};

export const SANTILLANA_HN = {
  'es_Compartir-HN': mergeTranslations(DEFAULT_RESOURCES_ES, [courses_es_santillana_hn, grades_es_santillana_hn]),
  'en_Compartir-HN': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir-HN': [...DEFAULT_RESOURCES_PT],
};

export const SANTILLANA_MX_COMPARTIR = {
  'es_Compartir MX': mergeTranslations(DEFAULT_RESOURCES_ES, [courses_es_santillana_mx_compartir, grades_es_santillana_mx_compartir]),
  'en_Compartir MX': [...DEFAULT_RESOURCES_EN],
  'pt_Compartir MX': [...DEFAULT_RESOURCES_PT],
};

export const EDELVIVES_DIGITAL_PLUS = {
  'es_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_ES, [
    auth_es_edv,
    calendar_es_edv,
    classroom_es_edv,
    common_es_edv,
    courses_es_edv,
    demo_es_edv,
    editorial_es_edv,
    grades_es_edv,
    header_es_edv,
    kanban_es_edv,
    lemonade_es_edv,
    lesson_es_edv,
    phrase_es_edv,
    profile_es_edv,
    project_es_edv,
    signup_es_edv,
    tasks_es_edv,
    test_es_edv,
    titles_es_edv,
  ]),
  'en_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_EN, [
    auth_en_edv,
    calendar_en_edv,
    classroom_en_edv,
    common_en_edv,
    courses_en_edv,
    demo_en_edv,
    editorial_en_edv,
    grades_en_edv,
    header_en_edv,
    kanban_en_edv,
    lemonade_en_edv,
    lesson_en_edv,
    phrase_en_edv,
    profile_en_edv,
    project_en_edv,
    signup_en_edv,
    tasks_en_edv,
    test_en_edv,
    titles_en_edv,
  ]),
  'ca_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_ES, [
    accessibility_ca_edv,
    auth_ca_edv,
    calendar_ca_edv,
    classroom_ca_edv,
    common_ca_edv,
    courses_ca_edv,
    demo_ca_edv,
    editorial_ca_edv,
    grades_ca_edv,
    header_ca_edv,
    kanban_ca_edv,
    lemonade_ca_edv,
    lesson_ca_edv,
    phrase_ca_edv,
    profile_ca_edv,
    project_ca_edv,
    signup_ca_edv,
    tasks_ca_edv,
    test_ca_edv,
    titles_ca_edv,
  ]),
  'eu_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_ES, [
    accessibility_eu_edv,
    auth_eu_edv,
    calendar_eu_edv,
    classroom_eu_edv,
    common_eu_edv,
    courses_eu_edv,
    demo_eu_edv,
    editorial_eu_edv,
    grades_eu_edv,
    header_eu_edv,
    kanban_eu_edv,
    lemonade_eu_edv,
    lesson_eu_edv,
    phrase_eu_edv,
    profile_eu_edv,
    project_eu_edv,
    signup_eu_edv,
    tasks_eu_edv,
    test_eu_edv,
    titles_eu_edv,
  ]),
  'gl_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_ES, [
    accessibility_gl_edv,
    auth_gl_edv,
    calendar_gl_edv,
    classroom_gl_edv,
    common_gl_edv,
    courses_gl_edv,
    demo_gl_edv,
    editorial_gl_edv,
    grades_gl_edv,
    header_gl_edv,
    kanban_gl_edv,
    lemonade_gl_edv,
    lesson_gl_edv,
    phrase_gl_edv,
    profile_gl_edv,
    project_gl_edv,
    signup_gl_edv,
    tasks_gl_edv,
    test_gl_edv,
    titles_gl_edv,
  ]),
  'mx_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_ES, [
    accessibility_mx_edv,
    auth_mx_edv,
    calendar_mx_edv,
    classroom_mx_edv,
    common_mx_edv,
    courses_mx_edv,
    demo_mx_edv,
    editorial_mx_edv,
    grades_mx_edv,
    header_mx_edv,
    kanban_mx_edv,
    lemonade_mx_edv,
    lesson_mx_edv,
    phrase_mx_edv,
    profile_mx_edv,
    project_mx_edv,
    signup_mx_edv,
    tasks_mx_edv,
    test_mx_edv,
    titles_mx_edv,
  ]),
  'vl_Edelvives Digital Plus': mergeTranslations(DEFAULT_RESOURCES_ES, [
    accessibility_vl_edv,
    auth_vl_edv,
    calendar_vl_edv,
    classroom_vl_edv,
    common_vl_edv,
    courses_vl_edv,
    demo_vl_edv,
    editorial_vl_edv,
    grades_vl_edv,
    header_vl_edv,
    kanban_vl_edv,
    lemonade_vl_edv,
    lesson_vl_edv,
    phrase_vl_edv,
    profile_vl_edv,
    project_vl_edv,
    signup_vl_edv,
    tasks_vl_edv,
    test_vl_edv,
    titles_vl_edv,
  ]),
};
